module.exports = __webpack_public_path__ + "9c62dae6405c44b8847c58d23ad724d0.jpg";